<template>
    <div class="manager_dashboard">
        <user-menu />
        <div class="wrapper">
            <ManagerSidebarMenu v-if="checkIsManager() || ($store.state.switch_flag == 'Manager')" :show_menu="false" :show_back_button="true" back_link="managerReports"></ManagerSidebarMenu>
            <ManagerSidebarMenu v-if="checkIsMentor() || ($store.state.switch_flag == 'Mentor')" :show_menu="false" :show_back_button="true" back_link="mentorReports"></ManagerSidebarMenu>
            
            <div class="content-wrapper" style="padding-left: 165px;">
                <div class="container-wrapper center ml-2">
                    <div class="rep_audit_bg">
                        <div class="row">
                            <div class="col-12">
                                <h3 class="rep_heading pb-1 border-bottom text-uppercase">Rep Audit Trail</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12" >
                                <div class="row">
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-12 col-xl-2 px-0 pl-2" v-if="isManager == true">
                                                    <div class="cp-filter-label col-5 float-left"
                                                        style="width: 35%; margin-top: 20px;">Status:</div>
                                                    <b-form-select v-model="rep_status" @change="filterMenteeLists()"
                                                        :options="itemSource3"
                                                        style="margin-bottom: 10px !important; margin-top: 12px;"
                                                        class="col-7 float-left" />
                                            </div>
                                            <div class="col-12 col-xl-4 pr-5">
                                                <div class="cp-filter-label col-3 float-left pr-3" style="margin: 20px 0 0 0;">
                                                    User:</div>
                                                <b-form-select v-model="rep_mentee" :options="menteeLists"
                                                    @change="filterCompetency()"
                                                    style="margin-bottom: 10px !important; margin-top: 12px;"
                                                    class="col-9 float-left" />
                                            </div>
                                            <div class="col-12 col-xl-4 px-0">
                                                <div class="col-7 p-0 float-left">
                                                    <div class="cp-filter-label col-5 float-left"
                                                        style="width: 37%; margin-top: 20px;">Date Range:</div>
                                                    <b-form-select v-model="rep_days" @change="filterCompetency()"
                                                        :options="itemSource2"
                                                        style="margin-bottom: 10px !important; margin-top: 12px;"
                                                        class="col-7 float-left" />
                                                </div>
                                                <div class="col-5 p-0 float-left pl-4"
                                                    style="margin-top: 15px; padding-bottom: 10px !important;">
                                                    <div class="col-2 float-left p-0 custom-checkbox">
                                                        <input name="show_comments" value="1" id="show_comments_checkbox"
                                                            type="checkbox" class="custom-control-input" v-model="show_comments"
                                                            @click="changeShowComments($event)"
                                                            style="margin-top: 5px; margin-left: 1px;">
                                                        <label for="show_comments_checkbox" class="custom-control-label"
                                                            style="margin-left: 30px; margin-top: 5px;"></label>

                                                    </div>
                                                    <div class="col-10 float-left p-0 pl-2 bold" style="margin-top:5px;">Show Comments
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-xl-2 px-0 pl-2" v-if="isManager == false">
                                                    &nbsp;
                                            </div>
                                            <div class="col-12 col-xl-2"
                                                style="float: right; text-align: right; margin-top: 12px;">

                                                <div v-if="results.length > 0" class="" style="float: right;margin-left: 15px;"
                                                    @click="shareButtonModal()">
                                                    <img class="" src="@/assets/Send_Report_Button.svg" alt="MentorMentee"
                                                        width="24px" style="cursor: pointer;" />
                                                </div>

                                                <div v-if="results.length > 0"
                                                    style="margin-left: 15px; margin-top: 3px; float: right; margin-right: 0px; margin-top: 2px;"
                                                    @click="exportCSVAction()">
                                                    <img class="" src="@/assets/Download_Report.svg" alt="MentorMentee" width="24px"
                                                        style="cursor: pointer;" />
                                                </div>

                                                <div v-if="isManager == true"
                                                    style="margin-left: 15px; margin-top: 3px; float: right; margin-right: 0px; margin-top: 2px;"
                                                    @click="isRepAuditStatsModalVisible = true">
                                                    <img class="" src="@/assets/Rep_Stats_Button.svg" alt="MentorMentee"
                                                        width="24px" style="cursor: pointer;" />
                                                </div>

                                                
                                            </div>
                                            <div style="clear: both;"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="clear: both;"></div>
                    <div class="rep_audit_bg pt-0">

												
                        <div class="row report_heading px-3" v-if="show_comments == true">
                            <div style="width: 7%; cursor: pointer;" v-on:click="sortMethod('submitted')">
                                Submitted
                                <i v-if="sortField == 'submitted' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'submitted' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-if="!rep_mentee" style="width: 15%; cursor: pointer;" class=""
                                v-on:click="sortMethod('description')">
                                Task
                                <i v-if="sortField == 'description' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'description' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-else style="width: 15%; cursor: pointer;" class=""
                                v-on:click="sortMethod('description')">
                                Task
                                <i v-if="sortField == 'description' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'description' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-if="!rep_mentee" style="width: 12%; cursor: pointer;" class=""
                                v-on:click="sortMethod('tasklist_name')">
                                Skill Sets
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-else style="width: 17%; cursor: pointer;" class=""
                                v-on:click="sortMethod('tasklist_name')">
                                Skill Sets
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>

                            <div v-if="!rep_mentee" class="" style="width: 15%;cursor: pointer;"
                                v-on:click="sortMethod('mentee_name')">
                                {{ menteeTitle }}
                                <i v-if="sortField == 'mentee_name' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'mentee_name' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-if="!rep_mentee" class="" style="width: 12%;cursor: pointer;"
                                v-on:click="sortMethod('mentor_name')">
                                Approved by
                                <i v-if="sortField == 'mentor_name' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'mentor_name' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-else class="" style="width: 18%; cursor: pointer;"
                                v-on:click="sortMethod('mentor_name')">
                                Approved by
                                <i v-if="sortField == 'mentor_name' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'mentor_name' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-if="!rep_mentee" class="" style="width: 13%; cursor: pointer;"
                                v-on:click="sortMethod('timeOnTask')">
                                Time
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-else class="" style="width: 15%; cursor: pointer;"
                                v-on:click="sortMethod('timeOnTask')">
                                Time
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div class="" style="width: 8%;cursor: pointer;"
                                v-on:click="sortMethod('score')">
                                Rating
                                <i v-if="sortField == 'score' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'score' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div class="" style="width: 7%; cursor: pointer;"
                                v-on:click="sortMethod('createdAt')">
                                Approved
                                <i v-if="sortField == 'createdAt' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'createdAt' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div class="" style="width: 10%;" v-if="show_comments == true">
                                Comments
                            </div>
                            <div class="col-12 padding-lr-5">
                                <div class="custom_heading_hr"></div>
                            </div>
                        </div>
												
                        <div class="row report_heading px-3" v-else>
                            <div style="width: 7%; cursor: pointer;" class="" v-on:click="sortMethod('submitted')">
                                Submitted
                                <i v-if="sortField == 'submitted' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'submitted' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-if="!rep_mentee" style="width: 18%; cursor: pointer;" class=""
                                v-on:click="sortMethod('description')">
                                Task
                                <i v-if="sortField == 'description' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'description' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-else style="width: 18%;cursor: pointer;" class=""
                                v-on:click="sortMethod('description')">
                                Task
                                <i v-if="sortField == 'description' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'description' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-if="!rep_mentee" style="width: 14%; cursor: pointer;" class=""
                                v-on:click="sortMethod('tasklist_name')">
                                Skill Sets
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-else style="width: 19%;cursor: pointer;" class=""
                                v-on:click="sortMethod('tasklist_name')">
                                Skill Sets
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>

                            <div v-if="!rep_mentee" class="" style="width: 15%;cursor: pointer;"
                                v-on:click="sortMethod('mentee_name')">
                                {{ menteeTitle }}
                                <i v-if="sortField == 'mentee_name' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'mentee_name' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-if="!rep_mentee" class="" style="width: 12%; cursor: pointer;"
                                v-on:click="sortMethod('mentor_name')">
                                Approved by
                                <i v-if="sortField == 'mentor_name' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'mentor_name' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-else class="" style="width: 18%; cursor: pointer;"
                                v-on:click="sortMethod('mentor_name')">
                                Approved by
                                <i v-if="sortField == 'mentor_name' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'mentor_name' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-if="!rep_mentee" class="" style="width: 13%; cursor: pointer;"
                                v-on:click="sortMethod('timeOnTask')">
                                Time
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div v-else class="" style="width: 15%; cursor: pointer;"
                                v-on:click="sortMethod('timeOnTask')">
                                Time
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div class="" style="width: 10%; cursor: pointer;"
                                v-on:click="sortMethod('score')">
                                Rating
                                <i v-if="sortField == 'score' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'score' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div class="" style="width: 10%; cursor: pointer;"
                                v-on:click="sortMethod('createdAt')">
                                Approved
                                <i v-if="sortField == 'createdAt' && sortBy == 'ASC'" class="fa fa-sort-asc"
                                    aria-hidden="true"></i>
                                <i v-if="sortField == 'createdAt' && sortBy == 'DESC'" class="fa fa-sort-desc"
                                    aria-hidden="true"></i>
                            </div>
                            <div class="col-12 p-0 padding-lr-5">
                                <div class="custom_heading_hr"></div>
                            </div>
                        </div>

                        <div v-show="loading" class="loading_show">
                            <div class="spinner-border text-danger"></div>
                        </div>

                        <div class="row">
                            <div class="col-12 p-0 px-3" v-if="results.length > 0">
                                <div class="view-accountlist">
                                    <div v-if="show_comments == true">
                                        <div class="row report_view px-3" v-for="(result, index) in results">

                                            <div style="width: 7%;">
                                                {{ result.submittedDate }}
                                            </div>
                                            <div v-if="!rep_mentee" class=" txt_break" style="width: 15%;">{{
                                                result.description }}</div>
                                            <div v-else class=" txt_break" style="width: 15%;">{{
                                                result.description }}</div>
                                            <div v-if="!rep_mentee" class=" txt_break" style="width: 12%;">{{
                                                result.tasklist_name }}</div>
                                            <div v-else class=" txt_break" style="width: 17%;">{{
                                                result.tasklist_name }}</div>
                                            <div v-if="!rep_mentee" class=" txt_break" style="width: 15%;">{{
                                                result.mentee_name }}.</div>
                                            <div v-if="!rep_mentee" class=" txt_break" style="width: 12%;">{{
                                                result.mentor_name }}.</div>
                                            <div v-else class=" txt_break" style="width: 18%;">{{
                                                result.mentor_name }}.</div>
                                            <div v-if="!rep_mentee" class="" style="width: 13%;">{{
                                                result.timeOnTask }}.</div>
                                            <div v-else class="" style="width: 15%;">{{ result.timeOnTask }}
                                            </div>
                                            <div class="" style="width: 8%;" v-if="result.score != 0">{{
                                                result.score }}</div>
                                            <div class="" style="width: 8%;" v-else></div>
                                            <div class="" style="width: 7%;">{{ result.updatedDate }}</div>
                                            <div class="" style="width: 10%;"
                                                v-if="show_comments == true && result.score != 'Skill Pass'">
                                                <b>{{ result.mentee_name }}.-</b> {{ result.menteeComment }}<br />
                                                <b>{{ result.mentor_name }}.-</b> {{ result.comment }}
                                            </div>
                                            <div class="" style="width: 10%;" v-else>
                                                &nbsp;
                                            </div>
                                            <div class="col-12 padding-lr-5">
                                                <div class="custom_hr"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="row report_view px-3" v-for="(result, index) in results">

                                            <div style="width: 7%;">
                                                {{ result.submittedDate }}
                                            </div>
                                            <div v-if="!rep_mentee" class=" txt_break" style="width: 18%;">{{
                                                result.description }}</div>
                                            <div v-else class=" txt_break" style="width: 18%;">{{
                                                result.description }}</div>
                                            <div v-if="!rep_mentee" class=" txt_break" style="width: 14%;">{{
                                                result.tasklist_name }}</div>
                                            <div v-else class=" txt_break" style="width: 19%;">{{
                                                result.tasklist_name }}</div>
                                            <div v-if="!rep_mentee" class=" txt_break" style="width: 15%;">{{
                                                result.mentee_name }}.</div>
                                            <div v-if="!rep_mentee" class=" txt_break" style="width: 12%;">{{
                                                result.mentor_name }}.</div>
                                            <div v-else class=" txt_break" style="width: 18%;">{{
                                                result.mentor_name }}.</div>
                                            <div v-if="!rep_mentee" class="" style="width: 13%;">{{
                                                result.timeOnTask }}.</div>
                                            <div v-else class="" style="width: 15%;">{{ result.timeOnTask }}
                                            </div>
                                            <div class="" style="width: 10%;" v-if="result.score != 0">{{
                                                result.score }}</div>
                                            <div class="" style="width: 10%;" v-else></div>
                                            <div class="" style="width: 10%;">{{ result.updatedDate }}</div>
                                            <div class="col-12 padding-lr-5">
                                                <div class="custom_hr"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style="clear: both;"></div>
                                <div class="col-12 float-left override-padding pagination-wrapper" v-if="this.loading == false">
                                    <Pagination ref="Pagination" :currentPage="currentPage" :totalRows="rows" :perPage="perPage"
                                        :showPaginatedFunction="showNaicsofPaginated" :showPerPageFunction="perPagePaginated"
                                        :totalPages="totalPages" :sNo="sno">
                                    </Pagination>
                                </div>
                            </div>
                            <div class="col-12 p-0 px-3" style="text-align: center;" v-else-if="results.length == 0 && loading == false">
                                No records found.
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <BatchModal :isModalVisible="isExportModalVisible" @close="isExportModalVisible = false">
            <span v-if="loading" class="pull-right text-danger">
                Loading...
            </span>
            <div slot="header" class="sub-heading"></div>
            <div slot="body">
                <div class="">
                    <div class="export-details">
                        Exported: {{ rowsExportedCSV }} of {{ rowsCSV }}
                    </div>
                    <div class="percentage-text">
                        {{ percentage }}
                    </div>
                    <div class="batch-box">
                        <div class="batch-loading" id="batch-loading">
                            &nbsp;
                        </div>
                    </div>
                    <div class="download-link" @click="downloadFunc()" v-if="percentage == '100%'">
                        Download CSV File
                    </div>
                </div>
            </div>
            <div slot="footer" class="col-3 override-padding">

            </div>
        </BatchModal>

        <ShareReportModal :isModalVisible="isModalVisible" @close="isModalVisible = false, share_email = ''">
            <span v-if="loading" class="pull-right text-danger">
                Loading...
            </span>
            <div slot="header" class="sub-heading">
                <h3>Share Report</h3>
            </div>
            <div slot="body">
                <div v-if="showShareSuccess == true" class="col-12 override-padding"
                    style="color: #68C47E; text-align: center; margin-bottom: 15px;">
                    <b>Report shared successfully!</b>
                </div>
                <div class="col-12 override-padding">
                    <input v-model="share_email" name="share_email" placeholder="Enter Email..."
                        class="col-lg-12 input-text form-control" style="line-height: 30px " v-validate="'required|email'"
                        @keyup="checkEmail()" data-vv-as="Email address" maxlength="255" />
                    <div v-show="verrors.has('share_email')" class="validate-warning-msg">{{ verrors.first('share_email') }}
                    </div>
                </div>
                <div style="clear: both;" class="margin-bottom-10"></div>


                <div v-if="showWait == false" class="col-12 override-padding text-align-right">
                    <button :disabled="share_button_disable" v-on:click="shareButtonSubmit()"
                        class="btn ma-blue-btn col-3 input-height-25 createBtn"
                        style="line-height: 30px; border-radius: 10px;"><b>{{ submit_text }}</b></button>
                </div>
                <div v-if="showWait == true" class="col-12 override-padding text-align-right">
                    <button disabled="true" class="btn ma-blue-btn col-lg-3"
                        style="line-height: 30px; border-radius: 10px;"><b>Please wait...</b></button>
                </div>

            </div>
            <div slot="footer" class="col-3 override-padding">

            </div>
        </ShareReportModal>

        <RepsAuditStatsModal v-if="this.isManager == true" ref="rep_audit_stats"
            :isModalVisible="isRepAuditStatsModalVisible" @close="isRepAuditStatsModalVisible = false">

        </RepsAuditStatsModal>



    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import router from '../../router/index.js';
import store from '../../store/store.js';
import moment from 'moment';
import BatchModal from '../admin/reports/report_loading_modal.vue';
import ShareReportModal from '../admin/create-tasklist-modal.vue';
import RepsAuditStatsModal from '../manager/rep_audit_stats_modal.vue';
import VeeValidate from 'vee-validate';
import Pagination from '../pagination.vue';
import ManagerSidebarMenu from '@/components/shared/manager_sidebar_menu.vue';
import MentorSidebarMenu from '@/components/shared/mentor_sidebar_menu.vue';
import { checkIsManager, checkIsMentor } from '@/components/shared/utils.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields' });

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('MMM DD, YYYY')
    }
});

export default {
    data() {
        return {
            loading: false,
            results: [],
            items: [],
            items2: [],
            taskLists: [],
            rep_tasklist: '',
            menteeStr: '',
            menteeLists: [{ value: "", text: "All" },],
            rep_mentee: '',
            rep_task_list: '',
            rep_status: 'Active',
            itemSource3: [
                { value: "Active", text: "Active" },
                { value: "Inactive", text: "Inactive" },
                { value: "All", text: "All" },
            ],
            itemSource2: [
                { value: "", text: "Select Date Range" },
                { value: "7", text: "Last 7 days" },
                { value: "15", text: "Last 15 days" },
                { value: "30", text: "Last 30 days" },
                { value: "180", text: "Last 6 Months" },
                { value: "All", text: "All Time" }
            ],
            usertypeLists: [
                { value: "", text: "Both" },
                { value: "ROLE_MENTEE", text: "Mentee" },
                { value: "ROLE_APPRENTICE", text: "Apprentice" },
            ],
            usertypeOption: '',
            sortField: 'createdAt',
            sortBy: 'DESC',
            isExportModalVisible: false,
            percentage: '0%',
            fileName: '',
            totalCSVPages: 0,
            perCSVPage: 100,
            rowsCSV: 0,
            rowsExportedCSV: 0,
            currentCSVPage: 1,
            apiUrl: '',
            menteeTitle: 'Mentee/Apprentice',
            showWait: false,
            showShareSuccess: false,
            isModalVisible: false,
            submit_text: 'Submit',
            share_email: '',
            share_button_disable: true,
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pageOptions: [],
            totalPages: 0,
            sno: 0,
            show_comments: false,
            isRepAuditStatsModalVisible: false,
            isManager: false,
        }
    },
    components: {
        UserMenu,
        GoBack,
        BatchModal,
        ShareReportModal,
        Pagination,
        RepsAuditStatsModal,
        ManagerSidebarMenu,
        MentorSidebarMenu,

    },
    methods: {
      filterMenteeLists() {
        this.getMenteeLists();
      },
        checkIsMentor() {
            return checkIsMentor();
        },
        checkIsManager() {
            return checkIsManager();
        },
        navigate(path) {
            router.push(path);
        },
        changeShowComments(event) {
            if (event.target.checked == true) {
                this.show_comments = true;
            }
            else {
                this.show_comments = false;
            }
        },
        checkEmail: function () {
            if ((this.verrors.items.length === 0)) {
                this.share_button_disable = false;
            }
            else {
                this.share_button_disable = true;
            }
        },
        shareButtonSubmit: function () {
            this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                    this.submit_text = 'Please wait...';
                    this.insertReportTracking('Share');
                    this.showWait = true;
                    this.currentCSVPage = 1;
                    this.rowsCSV = 0;
                    this.rowsExportedCSV = 0;
                    this.totalCSVPages = 0;
                    this.percentage = 0;
                    this.fileName = '';

                    const params = {};

                    if (this.rep_mentee) {
                        params.mentee = this.rep_mentee
                    } else {
                        params.menteeIdStr = this.menteeStr;
                    }
                    if (this.rep_days) {
                        params.days = this.rep_days;
                    } else {
                        params.days = '';
                    }
                    if (this.usertypeOption) {
                        params.role = this.usertypeOption
                    } else {
                        params.role = '';
                    }
                    if (this.sortField) {
                        params.sortfield = this.sortField
                    }
                    if (this.sortBy) {
                        params.sortby = this.sortBy
                    }
                    params.account_id = this.$store.state.user_accountid,
                        params.page = this.currentCSVPage;
                    params.perPage = this.perCSVPage;
                    params.fileName = this.fileName;
                    params.email = this.share_email;
                    params.show_comments = this.show_comments;

                    axios.get('/desktop/mentee-ratings-report-share-csv', {
                        params: params
                    })
                        .then(response => {
                            console.log(response.data);
                            this.share_email = '';
                            this.submit_text = 'Submit';
                            this.share_button_disable = true;
                            this.showWait = false;
                            this.showShareSuccess = true;
                            setTimeout(() => {
                                this.showShareSuccess = false;
                            }, 5000)
                        })
                        .catch(error => {

                        });



                }
            });

        },
        shareButtonModal() {
            this.isModalVisible = true;
            this.verrors.clear();
        },
        insertReportTracking: function (type) {
            axios('/desktop/reports-tracking',
                {
                    method: 'POST',
                    data: {
                        account_id: this.$store.state.user_accountid,
                        type: type
                    },
                })
                .then(() => {

                })
                .catch((error) => {

                });

        },

        downloadFunc: function () {
            this.insertReportTracking('Download');
            var url = this.apiUrl + '/custom/csv-view/' + this.fileName + '/Rep-Audit';
            window.location.href = url;
            this.isExportModalVisible = false;
            return false;
        },
        exportCSVAction: function () {
            this.isExportModalVisible = false;
            this.currentCSVPage = 1;
            this.rowsCSV = 0;
            this.rowsExportedCSV = 0;
            this.totalCSVPages = 0;
            this.percentage = 0;
            this.fileName = '';
            this.fetchRepAuditListCSV();
        },
        fetchRepAuditListCSV: function () {
            const params = {};

            if (this.rep_mentee) {
                params.mentee = this.rep_mentee
            } else {
                params.menteeIdStr = this.menteeStr;
            }
            if (this.rep_days) {
                params.days = this.rep_days;
            } else {
                params.days = '';
            }
            if (this.usertypeOption) {
                params.role = this.usertypeOption
            } else {
                params.role = '';
            }
            if (this.sortField) {
                params.sortfield = this.sortField
            }
            if (this.sortBy) {
                params.sortby = this.sortBy
            }
            params.account_id = this.$store.state.user_accountid,
                params.page = this.currentCSVPage;
            params.perPage = this.perCSVPage;
            params.fileName = this.fileName;
            params.show_comments = this.show_comments;

            axios.get('/desktop/mentee-ratings-report-csv', {
                params: params
            })
                .then(response => {
                    this.isExportModalVisible = true;
                    this.currentCSVPage = response.data.page;
                    this.rowsCSV = response.data.total_rows;
                    this.rowsExportedCSV = response.data.total_rows_exported;
                    this.totalCSVPages = response.data.total_pages;
                    this.percentage = response.data.percentage;
                    this.fileName = response.data.file_name;
                    document.getElementById("batch-loading").style.width = this.percentage;
                    if (this.currentCSVPage <= this.totalCSVPages) {
                        this.fetchRepAuditListCSV();
                    }
                })
                .catch(error => {

                });

        },

        showNaicsofPaginated() {
            this.currentPage = this.$refs.Pagination.currentPageValue;
            this.filterCompetency();
        },
        perPagePaginated() {
            this.currentPage = 1;
            this.$refs.Pagination.currentPageValue = 1;
            this.perPage = this.$refs.Pagination.perPageValue;
            this.filterCompetency();
        },
        sortMethod: function (field) {
            this.sortField = field;
            if (this.sortBy == 'ASC') {
                this.sortBy = 'DESC';
            }
            else {
                this.sortBy = 'ASC';
            }
            this.filterCompetency();
        },
        filterCompetency() {
            const params = {};

            if (this.rep_mentee) {
                params.mentee = this.rep_mentee
            } else {
                params.menteeIdStr = this.menteeStr;
            }
            if (this.rep_days) {
                params.days = this.rep_days;
            } else {
                params.days = '';
            }
            if (this.usertypeOption) {
                params.role = this.usertypeOption
            } else {
                params.role = '';
            }
            if (this.sortField) {
                params.sortfield = this.sortField
            }
            if (this.sortBy) {
                params.sortby = this.sortBy
            }
						this.currentPage = 1;
            params.page = this.currentPage;
            params.perPage = this.perPage;
            params.account_id = this.$store.state.user_accountid,
						this.loading = true;
            //console.log(params)
            axios.get('/desktop/mentee-ratings-report', {
                params: params
            })
						.then(response => {
							this.results = '';
								this.results = response.data.data;
								this.currentPage = response.data.page;
								if (this.currentPage > 1) {
										this.sno = this.perPage * (this.currentPage - 1);
								}
								else {
										this.sno = 0;
								}
								this.rows = response.data.total_rows;
								this.totalPages = response.data.total_pages;
								this.loading = false;
						})
						.catch(function (error) {
								console.log(error);
						});
        },
        getMenteeLists: function () {
            this.loading = true;
            const params = {};
            this.rep_mentee = '';
            this.results = [];
            this.menteeLists = [];
            this.menteeLists = [{ value: "", text: "All" }];
            params.account_id = this.$store.state.user_accountid;
            params.switch_flag = this.$store.state.switch_flag;
            params.status = this.rep_status;
            if (this.usertypeOption) {
                params.role = this.usertypeOption;
            } else {
                params.role = '';
            }
            axios.get('/desktop/audit-rep/filter/mentees', {
                params: params
            })
                .then(response => {
                    this.loading = false;
                    var Lists = response.data;
                    for (var i = 0; i < Lists.length; i++) {
                        this.menteeLists.push({
                            'value': Lists[i].value,
                            'text': Lists[i].display
                        });
                    }
                    this.menteeStr = '';
                    for (var i = 0; i < response.data.length; i++) {
                        this.menteeStr += response.data[i].value + ',';
                    }
                    const params = {};
                    params.menteeIdStr = this.menteeStr;
                    if (this.rep_days) {
                        params.days = this.rep_days;
                    } else {
                        params.days = '';
                    }
                    if (this.usertypeOption) {
                        params.role = this.usertypeOption
                    } else {
                        params.role = '';
                    }
                    if (this.sortField) {
                        params.sortfield = this.sortField
                    }
                    if (this.sortBy) {
                        params.sortby = this.sortBy
                    }
                    params.page = this.currentPage;
                    params.perPage = this.perPage;
                    params.account_id = this.$store.state.user_accountid,
                        axios.get('/desktop/mentee-ratings-report', {
                            params: params
                        })
                            .then(response => {
                                this.loading = false;
                                this.results = response.data.data;
                                this.currentPage = response.data.page;
                                if (this.currentPage > 1) {
                                    this.sno = this.perPage * (this.currentPage - 1);
                                }
                                else {
                                    this.sno = 0;
                                }
                                this.rows = response.data.total_rows;
                                this.totalPages = response.data.total_pages;
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        IsUserManager() {
            var roles = this.$store.state.roles;
            if (roles.indexOf('ROLE_ADMIN') > -1) {
                return true;
            }
            else {
                if (this.$store.state.switch_admin_roles && this.$store.state.switch_admin_roles.indexOf("ROLE_ADMIN") > -1) {
                    return true;
                } else {
                    return false;
                }
            }
        },

    },
    created: function () {
        this.loading = true;
        this.rep_days = '30';
        this.apiUrl = process.env.API_ENDPOINT;
        this.isManager = this.IsUserManager();
				this.usertypeOption = '';
				this.menteeTitle = 'Mentee/Apprentice';
				this.getMenteeLists();

    }
}
</script>

<style scoped>.circle {
    background-color: #2EACEE;
    border-radius: 50%;
    height: 36px;
    width: 36px;
    text-align: center;
}

.circle i {
    color: #FFF;
    font-size: 24px;
    text-align: center;
    padding-top: 5px;
    padding-right: 2px;
}

.print-section {
    font-family: "proxima-nova", sans-serif;
    color: #002F42;
}

.rep_audit_bg {
    background-color: #FFF;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 10px;
}

.rep_heading {
    font-size: 24px !important;
    font-weight: normal !important;
    margin-bottom: 10px;
}

.report_heading {
    padding-top: 8px;
    padding-bottom: 8px;
    font-weight: bold;
}

.report_view {
    padding-top: 8px;
    padding-bottom: 8px;
}

.txt_break {
    word-break: break-word;
}

.table-heading-seperator {
    border-bottom: 1px solid #707070;
}

.custom_heading_hr,
.custom_hr {
    width: 100%;
    margin: 5px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.custom_heading_hr {
    border-bottom: 3px solid rgba(0, 0, 0, 0.1);
}

.custom-select,
.custom-select:focus {
    background-color: #e6e6e6 !important;
    border-color: #e6e6e6 !important;
    color: #707070;
    border-radius: 10px;
}

.filterBtn {
    display: flex;
    margin: 0 auto;
}

.cp-filter-label {
    font-weight: bold;
    padding: 0px;
    margin: 0 5px;
    vertical-align: middle;
}

.sub-heading h3 {
    font-size: 15px;
}

.btn:disabled {
    background-color: #8b8b8b;
    color: #FFF;
}</style>



// WEBPACK FOOTER //
// src/components/manager/rep_audit_trail.vue